export default __webpack_public_path__ + "static/media/br.16d9aa03.svg";